import React from 'react';
import { Box, Typography } from '@mui/material';
import { styles } from './DocViewer.styles';

interface DocViewerProps {
  match: {
    params: {
      docName: string;
    };
  };
}

const DocViewer: React.FC<DocViewerProps> = ({ match }) => {
  const { docName } = match.params;

  const getHeaderName = (documentName: string): string => {
    switch (documentName) {
      case 'privacy-policy':
        return 'Privacy Policy';
      case 'terms-of-use':
        return 'Terms of Use';
      case 'product-tc':
        return 'Product Terms & Conditions';
      default:
        return '';
    }
  };
  return (
    <Box sx={styles.container}>
      <Typography sx={styles.title}>{getHeaderName(docName)}</Typography>
      <Box sx={styles.card}>
        <iframe
          src={`/docs/${docName}.html`}
          title="Document Viewer"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      </Box>
    </Box>
  );
};
export default DocViewer;
